'use client';
import React from 'react';

export default function FloatingPill({ visible }: { visible: boolean }) {
  if (!visible) return null;

  return (
    <div
      className="fixed bottom-8 left-1/2 z-50 floating-pill"
      style={{ transform: 'translateX(-50%)' }}
    >
      <a
        href="#download"
        className="flex items-center gap-3 px-6 py-3 rounded-full font-semibold text-sm transition-all duration-200 whitespace-nowrap"
        style={{
          background: '#7C3AED',
          color: 'white',
          boxShadow: '0 0 30px rgba(124,58,237,0.5), 0 8px 24px rgba(0,0,0,0.4)',
          border: '1px solid rgba(196,181,253,0.2)',
        }}
        onMouseEnter={e => {
          (e.currentTarget as HTMLElement).style.boxShadow = '0 0 40px rgba(124,58,237,0.7), 0 8px 32px rgba(0,0,0,0.5)';
          (e.currentTarget as HTMLElement).style.transform = 'scale(1.04)';
        }}
        onMouseLeave={e => {
          (e.currentTarget as HTMLElement).style.boxShadow = '0 0 30px rgba(124,58,237,0.5), 0 8px 24px rgba(0,0,0,0.4)';
          (e.currentTarget as HTMLElement).style.transform = 'scale(1)';
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2v10M8 8l4 4 4-4M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/>
        </svg>
        Download the Reader
        <span className="text-xs font-normal opacity-70">· Free</span>
      </a>
    </div>
  );
}